/** returns operation details
@return { Array }
*/
export const getOperationDetails = state => {
    return state.operationDetails
}

/**
@return { Array }
*/
export const getSolicitationCards = state => {
    return state.cardsSolicitationList
}

/** returns Has More Solicitation Cards
@return { Boolean }
*/
export const getSolicitationCardsHasMore = state => state.cardsSolicitationListHasMore
